<template>
  <form-layout :label="label">
    <read-only-input :value="dateValue" />
  </form-layout>
</template>

<script>
import FormLayout from '@/views/templates/FormLayout'
import ReadOnlyInput from "@/views/atoms/inputs/ReadOnlyInput";

export default {
  name: "DatetimeBrowseItem",
  components: {
    FormLayout,
    ReadOnlyInput,
  },
  inject: [
    '$moment'
  ],
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Date, null],
      required: true
    }
  },
  computed: {
    dateValue() {
      return this.value ? this.$moment(this.value).format('yyyy/MM/DD HH:mm:ss') : null;
    }
  },
}
</script>
